export function itemClick(el) {
    el.href = el.href + "?menuItemClickedId=" + el.parentNode.id;
}